import SingleDetail from "./SingleDetail";

export default SingleDetail;
